import React, { useState, useRef, useEffect } from 'react';
import { FaSearch } from '@react-icons/all-files/fa/FaSearch';

import * as Styled from './search.styles';
import { GoogleSearch } from '../../../../components/googleSearch/googleSearch.component';
import useOutsideClick from '../../../../utils/useOutsideClick';
import { getRelevantLocaleData } from '../../../../locales/config';

export const Search = () => {
  const [isActive, setIsActive] = useState(false);
  const inputRef = useRef(null);
  const componentRef = useRef(null);
  const searchButtonLabel = getRelevantLocaleData().googleSearchButtonLabel;
  const searchId = getRelevantLocaleData().googleSearchId;

  if (!searchId) {
    return null;
  }

  const toggleSearchForm = () => {
    setIsActive(prevActiveState => !prevActiveState);
  };

  useOutsideClick(componentRef, () => {
    setIsActive(false);
  });

  useEffect(() => {
    if (isActive) {
      inputRef.current.focus();
    } else {
      inputRef.current.blur();
    }
  }, [isActive]);

  return (
    <Styled.Search ref={componentRef}>
      <Styled.SearchTrigger onClick={toggleSearchForm} aria-label={searchButtonLabel}>
        <FaSearch aria-hidden="true" />
      </Styled.SearchTrigger>
      <Styled.SearchForm isActive={isActive}>
        <GoogleSearch isPadded={false} inputRef={inputRef} />
      </Styled.SearchForm>
    </Styled.Search>
  );
};
